import React from 'react';
import PropTypes from 'prop-types';


const FileLinkMessage = ({ link }) => (
  <div className="batch-processed">
    Please click
    <a id="download-link" target="_blank" href={link}> here</a> to open the combined file.
    <div>
      <em>Please allow popups from this site to have the file open automatically</em>
    </div>
  </div>
);

FileLinkMessage.propTypes = {
  link: PropTypes.string.isRequired,
};

export default FileLinkMessage;



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/FileLinkMessage.jsx